// A contact's fit grade against the target profiles. Hover for the reasons.
const LABEL = { A: "Great fit", B: "Good fit", C: "Possible fit", D: "Weak fit", "?": "Not enough data", X: "Not a fit" };

export default function FitChip({ fit }) {
  if (!fit) return <small className="muted">—</small>;
  const lines = [`${fit.profile}: ${LABEL[fit.grade]}${fit.grade !== "X" && fit.grade !== "?" ? ` (${fit.score}/100)` : ""}`];
  if (fit.excluded) lines.push(fit.excluded);
  if (fit.missing?.length) lines.push("Missing: " + fit.missing.join("; "));
  fit.reasons.forEach(r => lines.push(`${r.state === "match" ? "✓" : r.state === "miss" ? "✗" : "?"} ${r.rule}${r.state === "match" && r.points ? ` (+${r.points})` : ""}`));
  if (fit.confidence < 1 && fit.grade !== "?") lines.push(`Based on ${Math.round(fit.confidence * 100)}% of the rules; the rest need data.`);
  return <span className={`fit-chip fit-${fit.grade === "?" ? "unk" : fit.grade}`} title={lines.join("\n")} data-testid="fit-chip">
    <b>{fit.grade === "X" ? "Not a fit" : fit.grade}</b>{fit.grade !== "X" && fit.grade !== "?" && fit.confidence < 0.6 && <i>~</i>}
  </span>;
}
